import { render, staticRenderFns } from "./CourseCardPreview.vue?vue&type=template&id=124df290&scoped=true"
import script from "./CourseCardPreview.vue?vue&type=script&lang=js"
export * from "./CourseCardPreview.vue?vue&type=script&lang=js"
import style0 from "./CourseCardPreview.vue?vue&type=style&index=0&id=124df290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124df290",
  null
  
)

export default component.exports